export const IMAGE_BASE_URL="https://daalchini.s3.ap-south-1.amazonaws.com/dcprod";
export const API_BASE_URL="https://api-prod.daalchini.co.in";
export const WEB_SOCKET_BASE_URL="wss://api-prod.daalchini.co.in";